<template>
  <div class="ma-auto">
    <vue-headful :title="'Сводные оценки'"/>
    <v-layout style="max-width: 100%;" class="align-center">
      <v-breadcrumbs class="pa-0" :items="breadcrumbs">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-layout>
    <v-data-table
        :loading="loading"
        :headers="headers"
        :items="summaryVeds"
        :items-per-page="15"
        class="elevation-1"
        disable-pagination
        hide-default-footer
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                header.vertical ? 'vertical-header' : '',
                header.divider ? 'divider-header' : ''
              ]"
              :colspan="header.colspan || 1"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;"
            >
              <div :class="header.vertical ? 'vertical-text' : ''">{{ header.text }}</div>
            </th>
          </tr>
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                header.vertical ? 'vertical-header' : '',
                header.divider ? 'divider-header' : ''
              ]"
              :colspan="header.colspan || 1"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;"
            >
              <div :class="header.vertical ? 'vertical-text' : ''">{{ header.subText }}</div>
            </th>
          </tr>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="font-weight-bold">{{ item.name }}</div>
          <div class="caption grey--text">{{ item.recordbook }}</div>
        </template>

        <template v-slot:no-data>
          <v-alert
            :value="true"
            color="error"
            icon="mdi-alert"
          >
            Нет данных для отображения
          </v-alert>
        </template>
      </v-data-table>
  </div>
</template>

<script>
import veds from "@/helpers/api/veds";
export default {
  name: "SummaryVeds",
  data () {
    return {
      loading: true,
      summaryVeds: [],
      disciplines: [],
      headers: [
        {
          text: 'Студент',
          value: 'name',
          subText: '',
          divider: true
        }
      ]
    }
  },
  mounted () {
    this.getSummaryVeds()
  },
  computed: {
    breadcrumbs () {
      return [
        { text: 'Оценки', to: { name: 'Veds' }, exact: true },
        { text: `Группа ${this.groupID}`, to: `/Veds/${this.groupID}` },
        { text: 'Сводные оценки', disabled: true }
      ]
    },
    sem () {
      return this.$route.params.sem
    },
    groupID () {
      return this.$route.params.groupID
    }
  },
  methods: {
    async getSummaryVeds () {
      this.loading = true
      let data = await veds.getSummaryVed(this.groupID, this.sem)
      this.summaryVeds = data.summary
      this.disciplines = data.disciplines;
      this.disciplines.forEach(discipline => {
          this.headers.push({
            text: discipline.disciplina,
            subText: discipline.type,
            value: discipline.ratingID.toString(),
            align: 'center',
            vertical: true,
            sortable: false,
            divider: true
          });
        });
      this.loading = false
    }
  }
}
</script>

<style scoped>
.vertical-header {
  font-weight: 100 !important;
  font-size: 12px !important;
  padding: 4px !important;
  height: 100px;
  max-width: 80px;
  min-width: 50px;
  vertical-align: bottom;
}

.vertical-text {
  font-weight: 100 !important;
  text-align: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  margin: 0 auto;
  max-height: 100px;
  word-wrap: break-word;
}

.divider-header {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>